/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonPrimary } from '../../../../../../utils/Button';
import { GetNumberWithZero } from '../../../../../../utils/NumberFormatter';
import { GetDate } from '../../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-32">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`value-text line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    const navigate = useNavigate();
    const [isActive, setIsActive] = useState(false);

    const handleView = (ev) => {
        ev.stopPropagation();
        navigate(mkRelativeUrl(`/billing/invoices/${item?.id}/info`));
    };

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsActive(!isActive)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isActive,
                    'max-h-10': !isActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.invoiceTitle}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span className="line-clamp-1 capitalize">{item?.organization}</span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    name="Organization"
                    value={item.organization || '--'}
                    className="sm:hidden"
                />
                <TableInfoCard name="Date Issue" value={GetDate(item?.timeIssue)} isCapitalize />
                <TableInfoCard name="Date Due" value={GetDate(item?.timeDue)} isCapitalize />
                <TableInfoCard
                    name="Bill Amount"
                    value={GetNumberWithZero(item?.amountBilled)}
                    isCapitalize
                />
                <TableInfoCard
                    name="Paid Amount"
                    value={GetNumberWithZero(item?.amountPaid)}
                    isCapitalize
                />

                <div className="flex flex-row gap-px justify-end items-center">
                    <ButtonPrimary
                        btnType="button"
                        title="View"
                        onClick={handleView}
                        className="h-7 min-w-14 text-sm"
                    />
                </div>
            </div>
        </div>
    );
}

function TableMobile({ data }) {
    return (
        <div className="invoices_page_mobile_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Invoice Found</div>
                ) : (
                    data?.map((item) => <TableRow key={item.id} item={item} />)
                )}
            </div>
        </div>
    );
}

export default TableMobile;
